import type { ClientError } from "../../client/http.ts";
import { formatTime, saoPaulo } from "../../design/format/dates.ts";
import { movedTo } from "../../design/format/money.ts";
import { shellCopy } from "../copy.ts";
import { designCopy } from "../../design/copy.ts";

export function errorWords(error: ClientError): string {
  if (error.kind === "rede") return designCopy.semConexao;
  if (error.kind === "formato") return designCopy.erros.interno;
  const context = error.context ?? {};
  const text = (key: string) => (typeof context[key] === "string" ? String(context[key]) : undefined);
  switch (error.code) {
    case "ja-decidida": {
      const [quem, nome, verbo, as] = [text("quem"), text("nome"), text("verbo"), text("as")];
      if (verbo === undefined || as === undefined) return error.message;
      const who = quem === "nabla" ? designCopy.quem.aNabla : quem === "terminal" && nome ? designCopy.quem.terminal(nome) : nome;
      return who === undefined ? error.message : shellCopy.erroCom.jaDecidida(who, verbo, formatTime(as, saoPaulo));
    }
    case "cedo-demais": {
      const from = text("allowedFrom");
      return from === undefined ? error.message : designCopy.deNovoAs(formatTime(from, saoPaulo));
    }
    case "valor-mudou": {
      const now = movedTo(context);
      return now === undefined ? error.message : shellCopy.erroCom.valorMudou(now);
    }
    case "gateway-recusou":
      return error.detail === undefined ? error.message : shellCopy.erroCom.gatewayRecusou(error.detail);
    case "meta-recusou":
      return error.detail === undefined ? error.message : shellCopy.erroCom.metaRecusou(error.detail);
    case "limite-do-meta": {
      const until = text("ate");
      return until === undefined ? error.message : shellCopy.erroCom.limiteDoMeta(formatTime(until, saoPaulo));
    }
    case "nao-autenticado":
    case "invalido":
    case "token-invalido":
    case "token-usado":
    case "token-vencido":
      return error.message;
    default:
      return designCopy.erros[error.code];
  }
}

export function goneWords(error: ClientError, missing: string | undefined): string | undefined {
  if (error.kind !== "api" || (error.code !== "nao-encontrado" && error.code !== "fora-do-escopo")) return undefined;
  return missing ?? (error.code === "fora-do-escopo" ? designCopy.erros["fora-do-escopo"] : designCopy.erros["nao-encontrado"]);
}
